<template>
    <main>
        <section class="hero tw-w-full tw-relative">
            <div class="lg:tw-container tw-grid tw-grid-cols-1 lg:tw-grid-cols-2">
                <div class="hero-text tw-relative tw-flex tw-flex-col tw-items-center lg:tw-items-start tw-justify-end lg:tw-justify-center tw-text-center lg:tw-text-left">
                    <h1 class="tw-text-white">Bilan Auditif Gratuit<sup>1</sup></h1>
                    <h2 class="tw-text-white tw-mb-4 lg:tw-mb-0">Prenez rendez-vous<br>dès maintenant !</h2>
<!--                    <img src="@/assets/img/badge.png" class="badge">-->
                </div>
                <div class="form-container tw-flex tw-justify-center lg:tw-justify-end">
                    <Form v-if="!$store.state.formSuccess" />
                    <FormSuccess v-if="$store.state.formSuccess" />
                </div>
            </div>
        </section>

        <section class="pourquoi">
            <div class="tw-container">
                <h1 class="tw-text-center">Pourquoi faire tester son audition ?</h1>
                <p class="tw-text-black tw-text-center tw-text-base lg:tw-text-lg">Tester sa vue et son cœur est devenu naturel. Tester son audition est tout aussi nécessaire, pourtant, c’est rarement un sujet abordé. Aujourd’hui, la perte auditive est un véritable enjeu de santé publique. À partir de 50 ans, une baisse d’audition est normale, il est important d’en parler et d’être accompagné afin d’éviter toute conséquence sur la santé.</p>
                <p class="tw-text-black tw-text-center tw-text-base lg:tw-text-lg">C’est pourquoi nous vous invitons à venir chez Amplifon pour profiter d’un bilan auditif gratuit¹ et faire le point sur votre audition.</p>
                <div class="tw-flex tw-justify-center tw-items-center">
                    <button class="btn-page tw-uppercase tw-text-white tw-bg-black tw-w-full tw-text-2xl" v-scroll-to="'form'">J'en profite</button>
                </div>
            </div>
        </section>

        <section class="advantages">
            <div class="content">
                <div>
                    <!-- <h2 class="image-text tw-text-center">Bilan auditif<br>complet gratuit<sup>1</sup></h2> -->
                </div>

                <div>
                    <div class="tw-container">

                        <h2 class="tw-text-black tw-text-center tw-pb-8">Pourquoi choisir la méthode Amplifon  pour votre audition ?</h2>
                        <p class="tw-text-black tw-text-base tw-pb-8 tw-text-center tw-block tw-mx-auto tw-w-fit">Cette approche exclusive allie notre expertise unique à une attention de chaque instant</p>

                        <div class="list tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4 tw-pb-8">
                            <div>
                                <figure>
                                    <img src="~@/assets/img/icons/1.svg">
                                </figure>
                                <div class="text">
                                    <h3>Premier réseau de l’audition en France</h3>
                                    <p>Avec plus de 760 centres</p>
                                </div>
                            </div>
                            <div>
                                <figure>
                                    <img src="~@/assets/img/icons/2.svg">
                                </figure>
                                <div class="text">
                                    <h3>Efficacité scientifiquement validée<sup>2</sup></h3>
                                    <p>93% de nos clients bénéficient d’une amélioration significative de la compréhension</p>
                                </div>
                            </div>
                            <div>
                                <figure>
                                    <img src="~@/assets/img/icons/3.svg">
                                </figure>
                                <div class="text">
                                    <h3>Protocole de tests auditifs brevetés</h3>
                                    <p>permettant de définir avec précision votre profil auditif et de comprendre vos attentes</p>
                                </div>
                            </div>
                            <div>
                                <figure>
                                    <img src="~@/assets/img/icons/4.svg">
                                </figure>
                                <div class="text">
                                    <h3>Suivi personnalisé et illimité</h3>
                                    <p>pendant toute la durée de votre appareillage<sup>3</sup></p>
                                </div>
                            </div>
                            <div>
                                <figure>
                                    <img src="~@/assets/img/icons/5.svg">
                                </figure>
                                <div class="text">
                                    <h3>Aides auditives à la pointe de la technologie</h3>
                                    <p>adaptées à vos besoins et à votre budget</p>
                                </div>
                            </div>
                            <div>
                                <figure>
                                    <img src="~@/assets/img/icons/6.svg">
                                </figure>
                                <div class="text">
                                    <h3>Pionnier de l’audition</h3>
                                    <p>dans le monde depuis 1950</p>
                                </div>
                            </div>
                        </div>

                        <div class="tw-flex tw-justify-center tw-items-center lg:tw-justify-start">
                            <button class="btn-page tw-uppercase tw-text-white tw-bg-black  tw-text-2xl tw-mx-auto tw-block" v-scroll-to="'form'">J'en profite</button>
                        </div>

                        <div class="small-texts tw-text-center lg:tw-text-left">
                            <p class="tw-text-black"><sup>1</sup> Test à but non medical.</p>
                            <p class="tw-text-black"><sup>2</sup> Etude Big Data Amplifon, basée sur l’analyse des données de 77.000 patients venus dans un des 760 centres Amplifon pour des tests ou un essai d’appareillage entre 2018 et 2021.</p>
                            <p class="tw-text-black"><sup>3</sup> En France, jusqu’à la fin de l’utilisation de votre appareil conformément à nos obligations légales, sauf prestations non couvertes par la garantie.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>
<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
    },
};
</script>
